if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
        timer();
    });
}
function timer() {
    function getOffset() {
        return new Date()
            .toLocaleString("en-US", {
                timeZone: "America/Chicago",
                timeZoneName: "longOffset",
            })
            .replaceAll(":", "")
            .match(/([-\+][0-9]+)/)[1];
    }
    const containers = document.getElementsByClassName("timer-container");
    const dateClass = document.getElementsByClassName("date-timer");
    const hourClass = document.getElementsByClassName("hour-timer");

    const intervals = [];

    for (let i = 0; i < containers.length; i++) {
        const container = containers[i];
        const date = dateClass[i].textContent.trim();
        const hour = hourClass[i].textContent.trim();
        const endDateTime = new Date(`${date}T${hour}${getOffset()}`);
        const interval = setInterval(function () {
            const currentDateTime = new Date();
            const endTimeDiff = endDateTime - currentDateTime;
            const daysContainer = document.querySelector(".timer-dys");
            const hoursContainer = document.querySelector(".timer-hrs");
            const minutesContainer = document.querySelector(".timer-mins");
            const secondsContainer = document.querySelector(".timer-sec");
            const parentContainer = container.parentNode;
            const btn = parentContainer.querySelector(".btn.slider-btn");
            if (endTimeDiff <= 0) {
                clearInterval(interval);
                daysContainer.innerHTML = "00";
                hoursContainer.innerHTML = "00";
                minutesContainer.innerHTML = "00";
                secondsContainer.innerHTML = "00";
                container.classList.add("timer-container-hidden");
                parentContainer.classList.add("show-secondary-text");
                if (btn) {
                    btn.href = btn.dataset.secondaryLink;
                    btn.innerHTML = btn.dataset.secondaryText;
                }
                return;
            }
            const days = Math.floor(
                (endTimeDiff % (1000 * 60 * 60 * 24 * 365)) /
                    (1000 * 60 * 60 * 24)
            );
            const hours = Math.floor(
                (endTimeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
                (endTimeDiff % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((endTimeDiff % (1000 * 60)) / 1000);
            if (days === 0) {
                container.querySelector(".id-dys").style.display = "none";
                daysContainer.style.display = "none";
                container
                    .querySelector(".timer")
                    .classList.remove("timer-full");
                container
                    .querySelector(".timer-text")
                    .classList.remove("timer-text-full");
            }
            daysContainer.innerHTML = days.toString().padStart(2, "0");
            hoursContainer.innerHTML = hours.toString().padStart(2, "0");
            minutesContainer.innerHTML = minutes.toString().padStart(2, "0");
            secondsContainer.innerHTML = seconds.toString().padStart(2, "0");
            // container.querySelector(".timer").innerHTML = `${(days > 0) ?  + " : " : ""} ${hours.toString().padStart(2, "0")} : ${minutes.toString().padStart(2, "0")} : ${seconds.toString().padStart(2, "0")}`;
        }, 1000);

        intervals.push(interval);
    }
}
timer();
